import { type ReactElement, useMemo } from 'react';
import './authn-layout.less';
import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import { StartEnrollmentHeader } from './components/start-enrollment-header/start-enrollment-header';
import { EnrollmentHeader } from './components/enrollment-header/enrollment-header';
import { AuthenticationHeader } from './components/authentication-header/authentication-header';
import type { BannerProps } from '../Banner/banner';

export enum LayoutHeaders {
  AUTHENTICATION = 'AUTHENTICATION',
  START_ENROLL = 'START_ENROLL',
  ENROLL_CONSENT = 'ENROLL_CONSENT',
}

interface AuthnLayoutProps {
  children: React.ReactNode;
  logoUrl?: string | React.ReactNode;
  hexImage?: React.ReactNode;
  header: LayoutHeaders;
  banner?: BannerProps;
  renderCustomBanner?: ReactElement;
  hideLayout?: boolean;
}

export const AuthnLayout = ({
  children,
  logoUrl,
  hexImage,
  header,
  banner,
  renderCustomBanner,
  hideLayout,
}: AuthnLayoutProps) => {
  const loadLogo = useMemo(
    () =>
      typeof logoUrl === 'string' ? (
        <img src={logoUrl} alt="logo" className="card-header-logo" />
      ) : (
        logoUrl
      ),
    [logoUrl],
  );

  const renderHeader = useMemo(() => {
    switch (header) {
      case LayoutHeaders.AUTHENTICATION:
        return (
          <AuthenticationHeader
            banner={!renderCustomBanner ? banner : undefined}
            logoUrl={loadLogo}
            hexImage={hexImage}
          />
        );
      case LayoutHeaders.START_ENROLL:
        return <StartEnrollmentHeader />;
      case LayoutHeaders.ENROLL_CONSENT:
        return (
          <EnrollmentHeader banner={!renderCustomBanner ? banner : undefined} />
        );
      default:
        return <></>;
    }
  }, [header, banner, loadLogo, hexImage, renderCustomBanner]);

  return (
    <div
      className={`authn-layout-root ${header === LayoutHeaders.ENROLL_CONSENT ? 'authn-layout-consent' : ''} ${hideLayout && 'hide-layout'}`}
    >
      {renderCustomBanner}
      {renderHeader}
      <div className="authn-layout-body">{children}</div>
      <div className="authn-layout-footer">
        <ImprivataLogo />
      </div>
    </div>
  );
};
